import { TFunction } from "i18next"

type I18NReducerAction = {
  type: string
  payload: TFunction
}

const i18NInitialState = {
  t: (key: string) => key
} as {
  t: TFunction
}

export default function I18NReducer(state = i18NInitialState, action: I18NReducerAction) {
  switch (action.type) {
    case 'I18N_LOAD':
      return { t: action.payload }

    default:
      if (!state.t) {
        return { ...i18NInitialState }
      }

      return state
  }
}